import React from 'react';
import PropTypes from 'prop-types';


import OfferCard from 'containers/student/Profile/Offers/OfferCard'

const OffersGrid = ({ data, onRedeem, publicView }) => {    

    return (   
        data.map((item) => {

            return (
                <div key={item.id}>

                    <OfferCard item={ item }
                               publicView={ publicView }
                               onRedeem={ onRedeem }
                               />

                </div>
            );
        })
    );
};

OffersGrid.propTypes = {
    data:PropTypes.object,
    onRedeem: PropTypes.func,
    publicView: PropTypes.bool,
};

export default OffersGrid;
